<app-card class="mt-5 p-1">
    <app-card-body>
        <div class="alert alert-primary text-center">
            This module should be used in a larger device
        </div>
    </app-card-body>
</app-card>